<template>
  <div>
    <div class="text-center mb-3">
      <h5>Номера телефонов:</h5>
      <div v-for="(phone, key) in phones" :key="key">
        {{ phone.name }}: {{ phone.body }}
      </div>
    </div>
    <div class="">
      <div class="border" v-for="(dataLocal, key) in data" :key="key">
        <REFERENCES_APP v-model="dataLocal['note']" :partner="partner" />
        <div>
          <label>ФИО</label>
          <fg-input v-model="dataLocal['name']"></fg-input>
        </div>
        <div>
          <label>Номер телефона</label>
          <fg-input v-model="dataLocal['body']"></fg-input>
        </div>
      </div>
      <button class="btn btn-success w-100 mt-2" @click="add">Добавить</button>
    </div>
  </div>
</template>
<script>
import REFERENCES_APP from "../REFERENCES/APP.vue";
import { logger, errorNotify } from "../../../../plugins/functions";

export default {
  components: {
    REFERENCES_APP,
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  async created() {
    this.get();
  },
  data() {
    return {
      phones: [],
      data: [
        {
          note: null,
          body: null,
          name: null,
          disabled: false,
        },
        {
          note: null,
          body: null,
          name: null,
          disabled: false,
        },
      ],
    };
  },
  methods: {
    async add() {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.$http({
        url: `${partner["endpoint_url"]}clients/clients/${this.value.id}/phones/mass`,
        method: "POST",
        data: { phones: this.data },
        headers: {
          Authorization: `Bearer ${partner["api_secret_key"]}`,
        },
      })
        .then((response) => {
          this.data = [
            {
              note: null,
              body: null,
              name: null,
              disabled: false,
            },
            {
              note: null,
              body: null,
              name: null,
              disabled: false,
            },
          ];
          this.$emit("update", true);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    async get() {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.$http({
        url: `${partner["endpoint_url"]}clients/clients/${this.value.id}/phones`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${partner["api_secret_key"]}`,
        },
      })
        .then((response) => {
          this.phones = response.data.phones;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>